// Client mirror of functions-common/src/charts/engine/group.ts. Keep in sync.

import { CHART_KEY_UNASSIGNED } from '../limits.js'

export function groupRows(
  rows: Array<Record<string, unknown>>,
  breakdownField?: string
): Map<string, Array<Record<string, unknown>>> {
  const groups = new Map<string, Array<Record<string, unknown>>>()

  if (!breakdownField) {
    groups.set('total', rows)
    return groups
  }

  for (const row of rows) {
    const rawValue = row[breakdownField]

    if (Array.isArray(rawValue)) {
      if (rawValue.length === 0) {
        let list = groups.get(CHART_KEY_UNASSIGNED)
        if (!list) {
          list = []
          groups.set(CHART_KEY_UNASSIGNED, list)
        }
        list.push(row)
      } else {
        for (const item of rawValue) {
          const key = item == null || item === '' ? CHART_KEY_UNASSIGNED : String(item)
          let list = groups.get(key)
          if (!list) {
            list = []
            groups.set(key, list)
          }
          list.push(row)
        }
      }
    } else {
      const key = rawValue == null || rawValue === '' ? CHART_KEY_UNASSIGNED : String(rawValue)
      let list = groups.get(key)
      if (!list) {
        list = []
        groups.set(key, list)
      }
      list.push(row)
    }
  }

  return groups
}
